var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreLocationGenericIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#03a65b",
    d: "M 9.5 0 C 9.9 0.1 10.3 0.1 10.7 0.2 C 13.2 0.8 15.1 2.2 16.2 4.5 C 17.3 6.8 17.3 9.1 16.2 11.4 C 15.6 12.9 14.7 14.2 13.6 15.4 C 12.3 17.1 10.8 18.5 9.1 19.9 C 9.1 19.9 9 19.9 9 20 C 8.7 19.7 8.4 19.5 8.1 19.2 C 6.6 17.9 5.2 16.5 4 14.9 C 2.9 13.6 2 12.2 1.4 10.5 C 0.8 8.8 0.8 7.1 1.4 5.4 C 2 3.7 3 2.4 4.5 1.4 C 5.6 0.6 6.9 0.2 8.3 0 C 8.4 0 8.4 0 8.5 0 C 8.8 0 9.2 0 9.5 0 Z M 9 17.9 C 9 17.9 9.1 17.9 9.1 17.9 C 10.1 17 11.1 16 12 15 C 13.1 13.6 14.2 12.2 14.9 10.5 C 15.6 9.1 15.6 7.6 15.1 6.1 C 14.3 3.6 12.6 2.1 10.1 1.7 C 8.8 1.4 7.6 1.6 6.4 2.1 C 4.9 2.8 3.8 3.9 3.1 5.4 C 2.6 6.5 2.4 7.8 2.6 9 C 2.8 10.1 3.2 11 3.8 12 C 4.6 13.4 5.7 14.6 6.8 15.8 C 7.5 16.5 8.2 17.2 9 17.9 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03a65b",
    cx: 9,
    cy: 8.5,
    r: 2.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreLocationGenericIcon);
export default __webpack_public_path__ + "static/media/store-location-generic-icon.31e29627cd35ffa50e45a68b9b47b76e.svg";
export { ForwardRef as ReactComponent };